import React from "react";
import { useState, useEffect } from "react";
function AddGroup() {
  return (
    <>
      <div className="page-contents">
        <div className="page--breadcrumb">
          <a>Add Group</a>
        </div>
        <div className="page--data">
          <div className="program-form form-group">
            <div className="form-item">
              <span>Name:</span>
              <input type="text" />
            </div>
            <div className="form-item form-top">
              <span>Importers:</span>
              <div className="flex-check-importers">
                <div className="flex-check-inner">
                  <input type="checkbox" />
                  <span>Al Mahmoudia Vehicle Trading Co. Ltd </span>
                </div>
                <div className="flex-check-inner">
                  <input type="checkbox" />
                  <span>Al Tayer Motors LLC</span>
                </div>
                <div className="flex-check-inner">
                  <input type="checkbox" />
                  <span>Alfardan Premier Motors (L.L.C) </span>
                </div>
                <div className="flex-check-inner">
                  <input type="checkbox" />
                  <span>Ali Alghanim & Sons Automotive </span>
                </div>
                <div className="flex-check-inner">
                  <input type="checkbox" />
                  <span>Alpha International Tunisie </span>
                </div>
                <div className="flex-check-inner">
                  <input type="checkbox" />
                  <span>Mana Automotive S.A.L. </span>
                </div>
                <div className="flex-check-inner">
                  <input type="checkbox" />
                  <span>Mohsin Haider Darwish LLC </span>
                </div>
                <div className="flex-check-inner">
                  <input type="checkbox" />
                  <span>S.M.E.I.A. </span>
                </div>
                <div className="flex-check-inner">
                  <input type="checkbox" />
                  <span>Saad and Trad S.A.L. </span>
                </div>
                <div className="flex-check-inner">
                  <input type="checkbox" />
                  <span>Sardar Trading Agencies </span>
                </div>
              </div>
            </div>
            <div className="form-btns">
              <a>Save</a>
              <a>Cancel</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddGroup;
